<div class="page-container">
    <div class="page-content-container flex flex-col">
        <div class="flex basis-[7%] flex-row mb-3">
            <div class="flex flex-auto justify-start items-center content-center basis-40%">
                <h1>My Exports</h1>
            </div>
        </div>

        <div class="filter-section grid grid-cols-5 gap-3">
            <div>
                <app-export-types-select
                [form]="form"
                [required]="false"
                [label]="'Export Types'"
                [placeholder]="'None'"
                (readyEvent)="handleExportTypesReady()"
                (valueChangedEvent)="handleExportTypesValueChange($event)"></app-export-types-select>
            </div>

            <div>
                <app-upload-date
                [form]="form"
                [required]="false"
                [label]="'Create Date'"
                [initialValue]="30"
                (readyEvent)="handleCreateDateReady()"
                (valueChangedEvent)="handleCreateDateValueChange($event)"></app-upload-date>
            </div>

            <div class="pt-3">
                <button mat-flat-button class="primary-button"
                (click)="onGenerateGrid()">Generate</button>
            </div>
        </div>

        <div class="grid-section flex flex-[0_0_80%] max-w-[65%]">
            <app-my-exports-grid></app-my-exports-grid>
        </div>
    </div>
</div>